/** @format — shipment.list AG-UI component */

import React from "react";
import { Package, ChevronRight } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";

function formatEta(etaDate) {
  if (!etaDate) return "";
  try {
    const d = new Date(etaDate);
    if (Number.isNaN(d.getTime())) return String(etaDate);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return String(etaDate);
  }
}

export default function ShipmentListCard({
  componentId,
  props = {},
  onAction,
  disabled,
}) {
  const shipments = Array.isArray(props.shipments) ? props.shipments : [];
  const title = props.title ?? "Your shipments";

  const fireAction = (actionId, shipment) => {
    const action = props.actions?.find((a) => a.id === actionId);
    const ref = shipment?.reference ?? shipment?.bookingId ?? shipment?.bookingRef ?? shipment?.id;
    onAction?.({
      componentId,
      actionId,
      label: action?.label ?? actionId,
      value: ref ? String(ref).replace(/^#/, "").trim() : shipment?.id ?? null,
    });
  };

  if (!shipments.length) {
    return (
      <div className="rounded-lg border border-[#e4e7ec] bg-[#F9FAFB] p-4 text-[13px] text-[#667185]">
        No shipments found.
      </div>
    );
  }

  return (
    <div className="w-full min-w-0 rounded-lg border border-[#e4e7ec] bg-white overflow-hidden">
      <div className="px-4 py-3 border-b border-[#F2F4F7]">
        <p className="text-[14px] font-semibold text-[#101928]">{title}</p>
      </div>
      <ul className="divide-y divide-[#F2F4F7]">
        {shipments.map((s) => (
          <li key={s.id ?? s.reference}>
            <button
              type="button"
              disabled={disabled}
              onClick={() => fireAction("open_shipment", s)}
              className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-[#F9FAFB] disabled:opacity-50"
            >
              <Package className="w-4 h-4 text-[#667185] flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-0.5">
                  <p className="text-[13px] font-medium text-[#101928] truncate min-w-0">
                    {s.vehicle ?? s.reference ?? s.id}
                  </p>
                  <StatusBadge
                    status={s.detailedStatus ?? s.status}
                    className="max-w-[42%] sm:max-w-none"
                  />
                </div>
                <p className="text-[12px] text-[#667185] truncate">
                  {s.origin && s.destination
                    ? `${s.origin} → ${s.destination}`
                    : s.reference}
                </p>
                {s.etaDate ? (
                  <p className="text-[11px] text-[#98A2B3] mt-0.5">ETA {formatEta(s.etaDate)}</p>
                ) : null}
              </div>
              <ChevronRight className="w-4 h-4 text-[#98A2B3] flex-shrink-0" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
